import React from 'react'

import noop from 'lodash/noop'

import cn from '../../../../commons/src/libs/class-names'

export interface Props {
  classNames?: string[]
  header?: React.ReactElement
  children: React.ReactNode
  loader?: React.ReactNode
  fixedHeight?: boolean
  overlay?: React.ReactNode
  onOverlayClose?: React.MouseEventHandler
  isOverlayOpen?: boolean
  sidebar?: React.ReactNode
}

const PageContentLayout = ({
  classNames,
  header,
  children,
  loader,
  fixedHeight = false,
  overlay,
  onOverlayClose = noop,
  isOverlayOpen = false,
  sidebar,
}: Props) => (
  <div
    className={cn(
      'PageContentLayout',
      {fixedHeight, isOverlayOpen, hasSidebar: !!sidebar},
      classNames
    )}
  >
    {overlay && <div className="PageContentLayout__overlay">{overlay}</div>}
    <div onClick={onOverlayClose} className="PageContentLayout__curtainOverlay" />
    <main className="PageContentLayout__main">
      {header && <div className="PageContentLayout__header">{header}</div>}
      <div className="PageContentLayout__content">
        <div className="PageContentLayout__children">{children}</div>
        {loader && <div className="PageContentLayout__loader">{loader}</div>}
        {sidebar && (
          <aside className="PageContentLayout__aside">
            <div className="PageContentLayout__asideContent">{sidebar}</div>
          </aside>
        )}
      </div>
    </main>
  </div>
)

export default PageContentLayout
